export default {
   path: '/multicotizador/bsa/',
   name: 'bsa',
   children: [
      {
         path: '',
         name: 'bsa',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/bsa/views/bsaAdminView.vue'
            ),
      },
      {
         path: 'entidades',
         name: 'entidades',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/bsa/views/entidadesView.vue'
            ),
      },
      {
         path: 'usuarios',
         name: 'usuarios',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/bsa/components/UsuarioABM.vue'
            ),
      },
      {
         path: 'regiones',
         name: 'regiones',
         component: () =>
            import('@/modules/bsa/components/RegionABM.vue'),
      },
      {
         path: 'prospectos',
         name: 'prospectos',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/bsa/views/seguimientoProspectosView.vue'
            ),
      },
      {
         path: 'terminos',
         name: 'terminos',
         component: () =>
            import(
               /* webpackChunkName: "AltaClienteArt" */ '@/modules/bsa/components/TerminosABM.vue'
            ),
      },
      {
         path: 'descuentos',
         name: 'descuentos',
         component: () => import('@/modules/bsa/components/DescuentoABM.vue'),
      },
      {
         path: 'companias',
         name: 'companias',
         component: () => import('@/modules/bsa/components/CompaniaABM.vue'),
      },
      {
         path: 'empresas',
         name: 'empresas',
         component: () => import('@/modules/bsa/components/EmpresaABM.vue'),
      },
      {
         path: 'coberturas',
         name: 'coberturas',
         component: () => import('@/modules/bsa/components/CoberturasABM.vue'),
      },
   ],
};
